<template>
  <div>
   <div class='programme-filter'>
     <label class='labelabove'>Curriculum
      <select v-model='query.curriculum'>
        <option :value='null'>All</option>
        <option v-for='curriculum in curriculums' :key='curriculum.title'>{{curriculum.title}}</option>
      </select>
      </label>
      <label  class='labelabove'>Level
      <select v-model='query.level'>
        <option :value='null'>All</option>
        <option v-for='level in levels' :key='level.title'>{{level.title}}</option>
      </select>
      </label>
      <label  class='labelabove'>School level
      <select v-model='query.schoolLevel'>
        <option :value='null'>All</option>
        <option v-for='schoolLevel in schoolLevels' :key='schoolLevel.title'>{{schoolLevel.title}}</option>
      </select>
      </label>
      <label  class='labelabove'>Type
      <select v-model='query.type'>
        <option :value='null'>All</option>
        <option v-for='type in types' :key='type.title'>{{type.title}}</option>
      </select>
      </label>
    </div>
    <transition-group name="list" class='resourceTiles'>
      <div v-for='programme in filteredProgrammes' class='resourceTile cs-orange-learn' :key='programme.title'>
        <router-link :to="{name: 'educationprogramme', params: { slug: programme.urlSegment }}">
          <div>
            <img :src='programme.thumbnail.filename' v-if='programme.thumbnail'> 
            <div class='resourceText cs-orange-learn'><h2>{{programme.title}}</h2></div>
          </div>
        </router-link>
      </div>
    </transition-group> 
  </div>
</template>

<style>
.programme-filter {
  display: flex;
  flex-direction: row;
}

.labelabove {
  display: flex;
  flex-direction: column;
  flex-basis: 25%;
  padding: 2rem;
}
</style>

<script>
import axios from 'axios';
import _ from 'lodash';
import DatePicker from '../../components/DatePicker'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      query: {
        curriculum: null,
        level: null,
        schoolLevel: null,
        type: null
      }
    }
  },
  computed: {
   ...mapState({
     programmes: state => state.programmes,
     curriculums: state => state.curriculums,
     levels: state => state.programmeLevels,
     schoolLevels : state => state.schoolLevels,
     types: state => state.programmeTypes
   }),

   filteredProgrammes() {
     let filtered = _.filter(this.programmes, programme => {
       let curriculumMatch = (this.query.curriculum == null) ||
          _.reduce(programme.curriculums, (acc, x) => {
            return acc || (x.title == this.query.curriculum);
          }, false);

        let levelMatch = (this.query.level == null) ||
          _.reduce(programme.levels, (acc, x) => {
            return acc || (x.title == this.query.level);
          }, false);

        let schoolLevelMatch = (this.query.schoolLevel == null) ||
          _.reduce(programme.schoolLevels, (acc, x) => {
            return acc || (x.title == this.query.schoolLevel);
          }, false);

        let typeMatch = (this.query.type == null) ||
          _.reduce(programme.types, (acc, x) => {
            return acc || (x.title == this.query.type);
          }, false);
      
       return curriculumMatch && levelMatch && schoolLevelMatch && typeMatch;
     });

     return filtered;
   },
   breadcrumb() {
     return { name: "educationprogrammes", title: 'programmes' };
   }
  },
  methods: {
    dateChange(e) {
      this.dateFrom = e.dateFrom;
      this.dateTo = e.dateTo;
      this.update();
    },
    update() {
      // axios.get(`${this.$api}/education/programmes`).then(
      // (result) => {
      //     this.programmes = result.data.programmes;
      //     this.curriculums = result.data.curriculums;
      //     this.levels = result.data.levels;
      //     this.schoolLevels = result.data.schoolLevels;
      //     this.types = result.data.types;
      // });
      this.$store.dispatch('loadProgrammes');
    },
  },
  watch: {
      // '$route'() {
      //     if (this.query) {
      //       if (this.query.categories) {
      //           this.selectedCategories = this.query.categories.split(',');
      //       }
      //     }
      // }
  },
  created() {
      this.dateFrom = new Date();
      this.update();
  },
  mounted() {
     this.$emit('updateHead', "Education Programmes");
  },
  components: {
      'date-picker': DatePicker
  }
}
</script>